import { type IApplicationContext } from 'shared/types/applicationContext';

import { createApplicationState } from '../applicationState';
import { renderApplication } from '../renderApplication';

export function runApp(context: IApplicationContext): void {
  const store = createApplicationState(context);

  renderApplication({ context, store });
}
